export const validateFileType = (filename, fileTypes) => {
    const ext = filename.split('.').pop();
    if (!ext) {
        return false;
    }
    return fileTypes.includes(ext.toLowerCase());
};
